module.exports = __webpack_public_path__ + "static/media/eye.b9bdfed8.svg";